<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\surveyManual-1.png" alt="" /></div>
                <div>
                    <p>① Sau khi nộp [Bản cam kết] thì % tiến độ sẽ tăng lên, nhấn vào nút [Bảng khảo sát] ở trên thanh menu con, thì màn hình bảng khảo sát sẽ được hiển thị.</p>
                </div>
                <div><img src="/static\images\vi\newManual\surveyManual-2.png" alt="" /></div>
                <div>
                    <p>② Trả lời tất cả các câu hỏi trên màn hình bảng khảo sát.</p>
                    <p>③ Nhấn nút [Gửi đi] để nộp Bảng khảo sát.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn vào icon [Bảng khảo sát] ở trên thanh menu con, thì màn hình bảng khảo sát sẽ được hiển thị.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\survey_1.png" alt="" /></div>
                <div><p>② Trả lời tất cả các câu hỏi trên màn hình bảng khảo sát và đánh dấu vào ô xác nhận.</p></div>
                <div><p>③ Nhấn nút [Gửi đi] để nộp Bảng khảo sát.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\survey_2.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/survey_manual.vue